import { Check, Rocket, Zap } from "lucide-react";
import { useNavigate } from "react-router-dom";

const plans = [
  { id: "basico", name: "Plano Básico", price: "97", desc: "Pra quem quer organizar a casa e largar a comanda de papel.", features: ["Cardápio digital com QR code", "Controle de pedidos e mesas", "Controle de estoque", "Impressão automática", "Pix e cartão online", "Suporte por WhatsApp"], highlight: false, cta: "Começar com o Básico", color: "bg-white", badge: null },
  { id: "inteligente", name: "Plano Inteligente", price: "197", desc: "Tudo do Básico + a IA que atende seus clientes no WhatsApp.", features: ["Tudo do Plano Básico", "IA anotando pedidos 24h", "Gestão de equipe e entregadores", "Relatórios de vendas", "Suporte prioritário", "Cardápio assistido"], highlight: true, cta: "Quero o plano com IA", color: "bg-brutal-yellow", badge: "MAIS POPULAR" },
];

export const Pricing = () => {
  const navigate = useNavigate();
  const startTrial = (planId) => navigate("/login", { state: { register: true, plan: planId } });
  return (
    <section id="precos" data-testid="pricing" className="py-24 sm:py-32 bg-brutal-blue border-y-[3px] border-brutal-black relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.12] pointer-events-none" style={{ backgroundImage: "radial-gradient(#FFFFFF 1.5px, transparent 1.5px)", backgroundSize: "26px 26px" }} />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 bg-brutal-yellow border-[2.5px] border-brutal-black px-3.5 py-1.5 shadow-brutal-xs">
            <Zap size={14} strokeWidth={3} className="text-brutal-black" />
            <span className="font-mono text-[11px] font-bold uppercase tracking-widest text-brutal-black">PLANOS E PREÇOS</span>
          </div>
          <h2 className="mt-5 font-heading text-4xl sm:text-5xl lg:text-6xl tracking-tight text-white uppercase leading-[0.95]">
            Sem taxa por pedido.<br />
            <span className="bg-brutal-pink border-[3px] border-brutal-black px-3 inline-block shadow-brutal -rotate-1 text-white mt-2">Sem surpresa no fim do mês.</span>
          </h2>
          <p className="mt-6 text-base sm:text-lg text-white leading-relaxed font-medium">
            Mensalidade fixa, cancele quando quiser. Os primeiros 7 dias são por nossa conta pra você testar sem compromisso.
          </p>
        </div>
        <div className="mt-14 grid md:grid-cols-2 gap-7 sm:gap-8 max-w-4xl">
          {plans.map((p) => (
            <div key={p.id} data-testid={`pricing-card-${p.id}`} className={`relative ${p.color} border-[3px] border-brutal-black p-8 sm:p-10 flex flex-col ${p.highlight ? "shadow-brutal-xl" : "shadow-brutal-md"} hover:translate-y-[-4px] transition-all`}>
              {p.badge && (
                <span className="absolute -top-4 left-6 bg-brutal-pink text-white border-[2.5px] border-brutal-black px-4 py-1.5 shadow-brutal-sm font-mono text-[11px] font-bold uppercase tracking-widest rotate-[-2deg]">★ {p.badge}</span>
              )}
              <h3 className="font-heading text-2xl text-brutal-black uppercase leading-tight">{p.name}</h3>
              <p className="mt-2 text-sm text-brutal-black font-medium">{p.desc}</p>
              <p className="mt-7 flex items-end">
                <span className="font-mono text-base text-brutal-black align-top mr-1 mb-2 font-bold">R$</span>
                <span className="font-heading text-7xl text-brutal-black tracking-tight leading-none">{p.price}</span>
                <span className="font-mono text-sm text-brutal-black ml-1 mb-2 font-bold">/mês</span>
              </p>
              <ul className="mt-8 space-y-3 flex-1">
                {p.features.map((f) => (
                  <li key={f} className="flex items-start gap-3 text-sm text-brutal-black font-medium">
                    <span className="inline-flex border-2 border-brutal-black bg-brutal-lime p-0.5 shrink-0 mt-0.5">
                      <Check size={14} strokeWidth={3} className="text-brutal-black" />
                    </span>{f}
                  </li>
                ))}
              </ul>
              <button data-testid={`pricing-cta-${p.id}`} onClick={() => startTrial(p.id)} className={`mt-9 border-[3px] border-brutal-black px-7 py-4 font-heading uppercase tracking-tight text-base shadow-brutal-md hover:translate-y-[-3px] hover:shadow-brutal-lg active:translate-y-[2px] active:shadow-brutal-sm transition-all inline-flex items-center justify-center gap-2 ${p.highlight ? "bg-brutal-pink text-white" : "bg-brutal-black text-white"}`}>
                <Rocket size={18} strokeWidth={3} />{p.cta}
              </button>
            </div>
          ))}
        </div>
        <p className="mt-10 text-sm text-white font-medium">
          Já tem conta?{" "}
          <button data-testid="pricing-login-link" onClick={() => navigate("/login")} className="text-brutal-yellow underline underline-offset-4 hover:text-white font-bold font-mono uppercase tracking-wider">ENTRAR NO PAINEL →</button>
        </p>
      </div>
    </section>
  );
};
